import { render, staticRenderFns } from "./highlights-mss.vue?vue&type=template&id=20c6de40&scoped=true&"
import script from "./highlights-mss.vue?vue&type=script&lang=js&"
export * from "./highlights-mss.vue?vue&type=script&lang=js&"
import style0 from "./highlights-mss.vue?vue&type=style&index=0&id=20c6de40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c6de40",
  null
  
)

export default component.exports